/**
 * Shared constants for purchase requisition/order statuses
 * These should be used consistently across the application
 */

import type { ExtendedOrderStatus } from '@/utils/orderStatusColors';

/**
 * Available status options for purchase requisitions/orders
 */
export const STATUS_OPTIONS: readonly ExtendedOrderStatus[] = [
  'Pending',
  'Pending Action Facility Log',
  'Pending XO/Approving Official Signature',
  'Pending CDD action/feedback',
  'Pending RIC/KO/Natick',
  'On Order',
  'Partial',
  'Completed/Received',
  'Contract awarded',
  'Natick/MIPR completed',
  'Cancelled',
] as const;

/**
 * Purchase type options
 */
export const PURCHASE_TYPE_OPTIONS = [
  'GPC',
  'Natick/MIPR',
  'Contract',
  'GPC/GSA 25K',
  'MILSTRIP',
] as const;

/**
 * Priority options for asset acquisition orders
 */
export const PRIORITY_OPTIONS = [
  'Critical S&T',
  'Essential sustainment',
  'Enhancing',
  'Custom order',
] as const;

/**
 * WBS and CC (Work Breakdown Structure / Cost Center) options
 */
export const WBS_CC_OPTIONS = ['WBS 1', 'WBS 2', 'WBS 3', 'CC 1', 'CC 2', 'CC 3'] as const;

/**
 * Order status filter values (for dropdown)
 */
export const ORDER_STATUS_FILTERS = [
  { value: 'all', label: 'All Requisitions' },
  { value: 'pending', label: 'Pending' },
  { value: 'pending_action_facility', label: 'Pending Action Facility Log' },
  { value: 'pending_xo', label: 'Pending XO/Approving Official Signature' },
  { value: 'pending_cdd', label: 'Pending CDD action/feedback' },
  { value: 'pending_ric', label: 'Pending RIC/KO/Natick' },
  { value: 'on_order', label: 'On Order' },
  { value: 'partial', label: 'Partial' },
  { value: 'completed', label: 'Completed/Received' },
  { value: 'contract_awarded', label: 'Contract awarded' },
  { value: 'natick_mipr', label: 'Natick/MIPR completed' },
  { value: 'cancelled', label: 'Cancelled' },
] as const;
